import { driver } from 'driver.js'

let VueDriver = {}

VueDriver.steps = []

VueDriver.install = function (Vue, options) {
  // initialize Driver
  VueDriver.driver = driver({
    nextBtnText: 'Próximo →',
    prevBtnText: '← Anterior',
    doneBtnText: 'Pronto!',
    showProgress: true,
    progressText: '{{current}} de {{total}}',
  })
  // driver.highlight('selector');

  Vue.directive('driver-step', {
    bind(el, binding, vnode, oldVnode) {
      let step = {
        element: el,
        popover: {
          ...(binding.value ? binding.value.popover || {} : {}),
        },
      }
      if (binding.value && binding.value.index != null) {
        VueDriver.steps.splice(binding.value.index, 0, step)
      } else {
        VueDriver.steps.push(step)
      }
      if (binding.value && binding.value.onclick === true) {
        // This may cause a bug
        el.onclick = (event) => VueDriver.driver.highlight(step)
      }
    },
  })
  const setSteps = (steps) => {
    VueDriver.steps = steps
  }
  const startTour = (index) => {
    Vue.nextTick(() => {
      VueDriver.driver.setSteps([...VueDriver.steps])
      VueDriver.driver.drive()
    })
  }
  const startTourSingleTime = ({ index, tourId }) => {
    const driverHistory = JSON.parse(window.localStorage.getItem('driver-history') || '{}')
    if (driverHistory[tourId]?.toured) return
    setTimeout(() => startTour(index), 500)
    driverHistory[tourId] = {
      toured: true,
    }
    window.localStorage.setItem('driver-history', JSON.stringify(driverHistory))
  }
  const moveNext = () => {
    VueDriver.driver.moveNext()
  }
  const startTourNextDelayed = () => {
    setTimeout(() => {
      if (!VueDriver.driver.isActive()) {
        startTour()
      }
    }, 750)
  }
  Vue.prototype.$driver = Vue.$driver = {
    driver: VueDriver.driver,
    setSteps,
    startTourSingleTime,
    startTour,
    startTourNextDelayed,
    moveNext,
  }
}

export default VueDriver
